var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisbuesalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7778 0H3.22222C1.45 0 0 1.45 0 3.22222V25.7778C0 27.55 1.45 29 3.22222 29H25.7778C27.55 29 29 27.55 29 25.7778V3.22222C29 1.45 27.55 0 25.7778 0ZM25.7778 25.7778H3.22222V3.22222H25.7778V25.7778ZM6.44444 11.2778H9.66667V22.5556H6.44444V11.2778ZM12.8889 6.44444H16.1111V22.5556H12.8889V6.44444ZM19.3333 16.1111H22.5556V22.5556H19.3333V16.1111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbuesalIcon);
export default __webpack_public_path__ + "static/media/DisbuesalIcon.06a16a1f016da3a101be191ae98b8670.svg";
export { ForwardRef as ReactComponent };